import React from 'react';
import { FileDown, Layers3, ListChecks, Palette, PanelsTopLeft, Sparkles } from 'lucide-react';
import { useI18n } from '../../i18n/I18nContext';
import './Features.css';

const FEATURE_ICONS = [ListChecks, Layers3, PanelsTopLeft, Palette, FileDown, Sparkles];

const Features: React.FC = () => {
  const { content } = useI18n();
  const features = content.features;

  return (
    <section className="features section" aria-label={features.aria}>
      <div className="container">
        <div className="features__intro"><h2>{features.title}</h2><p>{features.intro}</p></div>
        <div className="features__grid">
          {features.items.map((feature, index) => {
            const Icon = FEATURE_ICONS[index];
            return (
              <article key={feature.title} className="features__card">
                <span className="features__icon"><Icon size={19} strokeWidth={1.7} /></span>
                <h3>{feature.title}</h3><p>{feature.description}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
